import { render } from "./SalesPointsDetailForm.vue?vue&type=template&id=61646c2a"
import script from "./SalesPointsDetailForm.vue?vue&type=script&lang=js"
export * from "./SalesPointsDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__